import { render } from "./Index.vue?vue&type=template&id=366abe89&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=366abe89&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-366abe89"

export default script